import RunnerGoalIcon from '@/components/Runner/RunnerGoalIcon'
import { CollectStatus } from '@/webgl/runner/entities/CollectibleEntity'
import { SequenceCompletion } from '@/webgl/runner/scenarios/SequenceCompletion'

import UIIcon from '../UI/UIIcon'

export type RunnerGoalListProps = {
  completion: SequenceCompletion
}

const RunnerGoalList = ({ completion }: RunnerGoalListProps) => {
  const ordered = !completion.view.unordered
  return (
    completion &&
    completion.blocks.length > 0 &&
    completion.blocks[0]?.goal.length && (
      <div className='flex gap-24 pt-20 md:pt-32'>
        {completion.blocks.map((block, indexBlock) => (
          <div key={indexBlock}>
            {block.goalText && (
              <p
                className={`${block.goalTextDM ? 'text-white' : ''} text-center text-14 md:text-16 font-semibold pb-12`}
              >
                {block.goalText}
              </p>
            )}
            <div className='RunnerGoalList RunnerGoalVariant bg-tertiary p-0 md:p-8 rounded-24 border-4 border-mid-blue'>
              <div className='relative flex gap-0 md:gap-10 min-h-80 min-w-80 rounded-24'>
                {block.goal.map((goal, indexGoal) => (
                  <RunnerGoalIcon
                    key={`${indexBlock}:${indexGoal}`}
                    ordered={ordered && block.status === CollectStatus.Neutral}
                    searched={
                      ordered &&
                      block.status === CollectStatus.Neutral &&
                      completion.currentBlock === indexBlock &&
                      indexGoal === block.collected.length
                    }
                    collected={block.collected.includes(goal)}
                    failed={block.failed.includes(goal)}
                    image={goal}
                    index={indexGoal}
                  />
                ))}

                <div className='absolute top-0 left-0 w-full h-full rounded-28 md:rounded-24 overflow-hidden flex items-center justify-center pointer-events-none'>
                  <div
                    className={`absolute top-0 left-0 w-full h-full bg-mid-blue transition-transform duration-300 delay-500 ease-out-quart ${block.status === CollectStatus.Succeed ? '' : 'translate-y-full'}`}
                  />
                  <UIIcon
                    icon='checkedRunner'
                    className={`relative text-cream text-48 md:text-64 transition-opacity duration-500 delay-500 ease-out-quad ${block.status === CollectStatus.Succeed ? '' : 'opacity-0'}`}
                  />
                </div>
                <div className='absolute top-0 left-0 w-full h-full rounded-28 md:rounded-24 overflow-hidden flex items-center justify-center pointer-events-none'>
                  <div
                    className={`absolute top-0 left-0 w-full h-full bg-coral transition-transform duration-300 delay-500 ease-out-quart ${block.status === CollectStatus.Failed ? '' : 'translate-y-full'}`}
                  />
                  <UIIcon
                    icon='failed'
                    className={`relative text-mid-blue text-48 md:text-64 transition-opacity duration-500 delay-500 ease-out-quad ${block.status === CollectStatus.Failed ? '' : 'opacity-0'}`}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  )
}
export default RunnerGoalList
